import { motion } from "framer-motion";
import { Box, Typography, Paper } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import React from "react";

export default function WhatItDoes({ t }) {
  const features = [
    {
      id: 1,
      text: t("Complete your scheduled chores in minutes, not hours."),
    },
    {
      id: 2,
      text: t(
        "Easily create schedules—daily, weekly, monthly, or fully custom"
      ),
    },
    {
      id: 3,
      text: t(
        "Set individual availability so every person gets the right shifts"
      ),
    },
    {
      id: 4,
      text: t("Add smart rules—days off, max shifts, and other restrictions"),
    },
    {
      id: 5,
      text: t("Build unlimited shifts per day, tailored to your needs"),
    },
    {
      id: 6,
      text: t("Assign everyday shifts fairly, and distribute holidays evenly"),
    },
    {
      id: 7,
      text: t("Save time with auto-scheduling that respects your rules"),
    },
    {
      id: 8,
      text: t("Export to Excel or save securely online—your choice"),
    },
  ];

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.12, duration: 0.5, ease: "easeOut" },
    }),
  };

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
        px: { xs: 2, md: 4 },
        textAlign: "center",
        maxWidth: "1000px",
        mx: "auto",
        color: "#f5faff",
      }}
    >
      <Typography
        variant="h3"
        component="h2"
        sx={{
          fontWeight: 800,
          mb: 6,
          color: "#ffffff",
          letterSpacing: "-0.5px",
        }}
      >
        {t("What we do")}
      </Typography>

      <Box
        component="ul"
        sx={{
          display: "grid",
          gap: 2,
          listStyle: "none",
          p: 0,
          m: 0,
        }}
      >
        {features.map((feature, index) => (
          <motion.li
            key={feature.id}
            custom={index}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={itemVariants}
          >
            <Paper
              elevation={3}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                px: 3,
                py: 2,
                borderRadius: 3,
                bgcolor: "rgba(255,255,255,0.08)",
                backdropFilter: "blur(6px)",
                transition: "all 0.3s ease",
                "&:hover": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  transform: "translateY(-3px)",
                },
              }}
            >
              <CheckCircleIcon
                sx={{ color: "#15e0fe", fontSize: 28, flexShrink: 0 }}
              />
              <Typography variant="h6" sx={{ color: "#ffffff" }}>
                {feature.text}
              </Typography>
            </Paper>
          </motion.li>
        ))}
      </Box>
    </Box>
  );
}
